module.exports = __webpack_public_path__ + "static/media/check.10a5b071.svg";